import React from 'react';
import TextField from 'apollo-react/components/TextField';
import FieldWrapper from '../../fields/FieldWrapper';

const TextFieldInput = ({
  id,
  type,
  label,
  placeholder,
  value,
  onChange,
  onBlur,
  helperText,
  showError,
  disabled,
  required,
  columnStyle,
  min,
  max,
  step,
  minRows,
}) => {
  const isTextarea = type === 'textarea';
  const isNumber = type === 'number';

  const textareaProps = isTextarea
    ? { multiline: true, minRows: minRows || 3 }
    : {};
  const numberProps = isNumber
    ? { inputProps: { min, max, step: step || 'any' } }
    : {};

  return (
    <FieldWrapper style={columnStyle}>
      <TextField
        id={id}
        name={id}
        type={isTextarea ? undefined : isNumber ? 'number' : type}
        label={label}
        placeholder={placeholder}
        value={value ?? ''}
        onChange={onChange}
        onBlur={onBlur}
        helperText={helperText}
        error={showError}
        disabled={disabled}
        required={required}
        fullWidth
        {...textareaProps}
        {...numberProps}
      />
    </FieldWrapper>
  );
};

export default TextFieldInput;
